const PaidInvoiceExportConstants = {
  PAID_INVOICE_EXPORT_TYPE: {
    MIRO_EXPORT: 'miro',
    INVOICE_EXPORT: 'invoice',
  },
};

module.exports = { PaidInvoiceExportConstants };
